import React from 'react';

import { Card } from 'shadcn/components/ui/Card';
import { cn } from 'shadcn/lib/utils';

import { NOOP, PalletQuickFillCollapsible } from './PalletQuickFillCollapsible';

/**
 * @typedef {{ id: number, code: string, displayName: string }} CompanySource
 *
 * @typedef {Object} QuickFillValues
 * @property {number} [companySourceId]
 * @property {number} [numCases]
 * @property {string} [expiration]
 * @property {string} [supplierLot]
 */

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {CompanySource[]} [props.companySourceOptions]
 * @param {boolean} [props.defaultOpen]
 * @param {import('../resolveExpirationDefaults').ExpirationDefaults} [props.expirationDefaults]
 * @param {boolean} [props.isThirdPartyAsn]
 * @param {(values: QuickFillValues) => void} [props.onApplyToAllPallets]
 * @param {number} [props.resetToken]
 */
function PalletQuickFillCard({
    className,
    companySourceOptions = [],
    defaultOpen = false,
    expirationDefaults,
    isThirdPartyAsn = false,
    onApplyToAllPallets = NOOP,
    resetToken,
}) {
    return (
        <Card className={cn('gap-0 border bg-muted/30 py-0 shadow-none', className)}>
            <PalletQuickFillCollapsible
                applyButtonLabel="Apply to all pallets"
                companySourceOptions={companySourceOptions}
                defaultOpen={defaultOpen}
                expirationDefaults={expirationDefaults}
                idPrefix="quick-fill"
                isThirdPartyAsn={isThirdPartyAsn}
                resetToken={resetToken}
                showDescription
                onApply={onApplyToAllPallets}
            />
        </Card>
    );
}

export { NOOP, PalletQuickFillCard };
